module.exports = __webpack_public_path__ + "src/images/products/active/6_ID Satdium Shorts.png";